module.exports = __webpack_public_path__ + "media/components/assets/sujung_01-38babb595094c2adbf4d0aade68bae35.png";